module.exports = __webpack_public_path__ + "static/media/holdingBeesGrass.9ea2208d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/holdingBeesGrass.jpg
// module id = 142
// module chunks = 0